import {
  TransferType,
  TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS,
} from '@/types/transactions';

// These are only meant to be seen by Staff Portal
export const getCheckDepositErrorReason = (
  errorReason: TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS | null,
) => {
  switch (errorReason) {
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.DEPOSIT_CHECK_CANCELED:
      return 'Deposit check canceled';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.DEPOSIT_CHECK_RETURNED:
      return 'Deposit check returned';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.EXCEEDS_PROGRAM_LIMIT:
      return 'Amount exceeds program limit';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.EXCEEDS_ACCOUNT_LIMIT:
      return 'Amount exceeds account limit';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.EXCEEDS_ACH_LIMIT:
      return 'Amount exceeds ACH limit';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.DEPOSIT_CHECK_ERROR:
      return 'Deposit check error';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.EXCEEDS_TRANSACTION_LIMIT:
      return 'Amount exceeds transaction limit';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.INSUFFICIENT_FUNDS:
      return 'Insufficient funds';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.CANCELED_OCR:
      return 'Canceled OCR';
    case TREASURY_PRIME_CHECK_DEPOSIT_ERROR_REASONS.UNKNOWN:
      return 'Unknown';
    default:
      return '';
  }
};

export function getTransactionDeliverySpeedFromTransferType(
  transferType: TransferType,
) {
  switch (transferType) {
    case TransferType.Book:
      return 'Book';
    case TransferType.Wire:
      return 'Express (Wire)';
    case TransferType.Check:
      return 'Mobile Check Deposit';
    case TransferType.ACH:
      return 'ACH - Standard';
    case TransferType.SameDayACH:
      return 'ACH - Same Day';
    default:
      return 'Other';
  }
}
